module.exports = __webpack_public_path__ + "img/awards4.cc90768c.svg";